import type { AppRoute } from './types';
import type { Portal } from './roles';
import { adminRoutes } from './adminRoutes';
import { principalRoutes } from './principalRoutes';
import { facultyRoutes } from './facultyRoutes';
import { studentRoutes } from './studentRoutes';
import { parentRoutes } from './parentRoutes';

/** Each portal's routes, by its route folder. */
export const portalRoutes: Record<Portal, AppRoute[]> = {
  administrator: adminRoutes,
  principal: principalRoutes,
  faculty: facultyRoutes,
  student: studentRoutes,
  parent: parentRoutes,
};

export type { AppRoute } from './types';
export { renderRoutes } from './renderRoutes';
export * from './roles';
